import { useEffect, useState } from 'react';
import { noop } from 'lodash';
import { InputAdornment, TextField } from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';

import useIsPrinting from '../../utilities/PrintUtilities';
import { useDebounced } from '../../utilities/Hooks';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .search-field': {
            padding: 0,
            margin: 0,

            '&, & .MuiInputBase-input': {
                fontSize: theme.typography.body2.fontSize,
            },

            '& .search-field-icon': {
                fontSize: '18px',
                lineHeight: '18px',
            },
        },
    },
}));

export default function SearchContainer({ onSearchChange, defaultValue, autoFocus, ...otherProps }) {
    const classes = useStyles();
    const isPrinting = useIsPrinting();
    const [current, setCurrent] = useState(defaultValue);

    const debouncedHandleFilterChange = useDebounced(onSearchChange, 250);

    function handleChange(e) {
        setCurrent(e.target.value);
    }

    useEffect(() => {
        debouncedHandleFilterChange(current);
    }, [debouncedHandleFilterChange, current]);

    useEffect(() => {
        setCurrent(defaultValue);
    }, [defaultValue]);

    return (
        <div className={classes.root} {...otherProps}>
            <TextField
                className="search-field"
                name="ContainerSearch"
                placeholder={isPrinting ? '' : 'Search...'}
                size="small"
                value={current || ''}
                fullWidth
                InputProps={{
                    autoFocus,
                    disableUnderline: true,
                    onChange: handleChange,
                    startAdornment: !isPrinting && (
                        <InputAdornment position="start">
                            <Search className="search-field-icon" />
                        </InputAdornment>
                    ),
                }}
            />
        </div>
    );
}

SearchContainer.defaultProps = {
    onSearchChange: noop,
};
